<template>
    <div class="social-btns d-flex align-center justify-center">
        <v-btn :width="small ? 30 : 40" :height="small ? 30 : 40" v-for="(item, i) in items" :key="'social-btn-' + i" tag="a" :target="capRunning ? '_system' : '_blank'" dark icon :href="item.url" style="background: rgba(0, 0, 0, 0.3)" :class="{'me-2': i != items.length-1, [item.color]: colored && item.color}">
            <svg v-if="item.icon === 'telegram'" fill="currentColor" xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 50 50" :width="iconSize + 'px'" :height="iconSize + 'px'"><path d="M46.137,6.552c-0.75-0.636-1.928-0.727-3.146-0.238l-0.002,0C41.708,6.828,6.728,21.832,5.304,22.445	c-0.259,0.09-2.521,0.934-2.288,2.814c0.208,1.695,2.026,2.397,2.248,2.478l8.893,3.045c0.59,1.964,2.765,9.21,3.246,10.758	c0.3,0.965,0.789,2.233,1.646,2.494c0.752,0.29,1.5,0.025,1.984-0.355l5.437-5.043l8.777,6.845l0.209,0.125	c0.596,0.264,1.167,0.396,1.712,0.396c0.421,0,0.825-0.079,1.211-0.237c1.315-0.54,1.841-1.793,1.896-1.935l6.556-34.077	C47.231,7.933,46.675,7.007,46.137,6.552z M22,32l-3,8l-3-10l23-17L22,32z"/></svg>
            <svg v-if="item.icon === 'tiktok'" fill="currentColor" :width="iconSize + 'px'" :height="iconSize + 'px'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2859 3333" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" image-rendering="optimizeQuality" fill-rule="evenodd" clip-rule="evenodd"><path d="M2081 0c55 473 319 755 778 785v532c-266 26-499-61-770-225v995c0 1264-1378 1659-1932 753-356-583-138-1606 1004-1647v561c-87 14-180 36-265 65-254 86-398 247-358 531 77 544 1075 705 992-358V1h551z"/></svg>
            <v-icon :size="iconSize" v-else>{{item.icon}}</v-icon>
        </v-btn>
    </div>
</template>

<script>

import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        colored: {type: Boolean, default: false},
        small: {type: Boolean, default: false},
    },
    data(){
        return {

        }
    },
    computed: {
        iconSize(){
            return this.small ? 17 : 23;
        },
        items(){
            let items = [];
            const appData = this.appData;
            if (appData.youtube_url){
                items.push({icon: 'mdi-youtube', url: appData.youtube_url, color: 'red darken-1'});
            }
            if (appData.facebook_url){
                items.push({icon: 'mdi-facebook', url: appData.facebook_url, color: 'indigo darken-1'});
            }
            if (appData.linkedin_url){
                items.push({icon: 'mdi-linkedin', url: appData.linkedin_url, color: 'blue darken-1'});
            }
            if (appData.telegram_url){
                items.push({icon: 'telegram', url: appData.telegram_url, color: 'blue'});
            }
            if (appData.messenger_url){
                items.push({icon: 'mdi-facebook-messenger', url: appData.messenger_url, color: 'blue lighten-1'});
            }
            if (appData.twitter_url){
                items.push({icon: 'mdi-twitter', url: appData.twitter_url, color: 'blue lighten-2'});
            }
            if (appData.tiktok_url){
                items.push({icon: 'tiktok', url: appData.tiktok_url, color: 'grey darken-3'});
            }
            if (appData.support_phone){
                items.push({icon: 'mdi-phone', url: `tel:${appData.support_phone}`, color: 'success'});
            }
            return items;
        },
        ...GlobalComputed
    },
    methods: {
        ...GlobalMethods
    }
}
</script>

<style lang="scss" scoped>

</style>